<div class="card" [ngClass]="bgColor">
  <div class="counts">
    <div class="flex space-between">
      <div class="counts-text">
        <h6 class="m-b-20 text-ellipsis" [ngClass]="{ clickable: clickTitle.observed }" (click)="clickTitle.emit()">
          {{ title }}
        </h6>
        @if (!isLoading) {
          <h2 class="text-ellipsis" [title]="total ?? 0 | numberFormat">
            {{ total ?? 0 | numberFormat }}
          </h2>
        } @else {
          <span class="text-placeholder cards">
            <span class="activity"></span>
          </span>
        }
      </div>
      <app-donut [data]="breakdown" (sliceClicked)="selectSite.emit($event.name)"/>
    </div>
  </div>
</div>
